import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IOrderLifetimeLoadParams, IOrderLifetimeCrudParams, IOrderLifetime } from './orderLifetime.interface';

export namespace OrderLifetimeAction {
  const actionCreator = actionCreatorFactory('OrderLifetime');

  export const loadList = actionCreator.async<void, IOrderLifetimeLoadParams, IApiErrorParams>('LOAD_LIST');
  export const create = actionCreator.async<IOrderLifetimeCrudParams, { orderLifetimeId: IOrderLifetime['orderLifetimeId'] }, IApiErrorParams>(
    'CREATE',
  );
  export const update = actionCreator.async<IOrderLifetimeCrudParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ orderLifetimeId: IOrderLifetimeCrudParams['orderLifetimeId'] }, void, IApiErrorParams>('REMOVE');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
